import { GroupTypes } from "../../../../abstract/controller/enum/GroupTypes";
import * as nodeUtils from "../../../../abstract/controller/utils/nodeUtils";
import * as pathUtils from "../../../../abstract/controller/utils/pathUtils";

export const showChoiceDrop = (srcElement, dstElement, dstElementParent, relVertical) => {
  const _srcId = nodeUtils.getID(srcElement);
  const _dstId = nodeUtils.getID(dstElement);

  if (!_srcId || _srcId === _dstId) {
    return false;
  }

  const _group = pathUtils.determineGroup(_srcId, _dstId);

  if (_group !== GroupTypes.INTERNAL_FUNCTIONS && _group !== GroupTypes.INTERNAL_GLOBALS) {
    return false;
  }

  if (nodeUtils.isParameter(dstElement)) {
    if (!nodeUtils.hasChoices(dstElement)) {
      return true;
    }
  }

  if (relVertical) {
    const _srcParentId = pathUtils.getIdParent(_srcId);

    if (
      _srcParentId !== _dstId &&
      nodeUtils.getIdChildWithName(dstElement, nodeUtils.getName(srcElement))
    ) {
      return false;
    }

    return true;
  }

  const _srcParentId = pathUtils.getIdParent(_srcId);
  const _dstParentId = pathUtils.getIdParent(_dstId);

  if (
    _srcParentId !== _dstParentId &&
    nodeUtils.getIdChildWithName(dstElementParent, nodeUtils.getName(srcElement))
  ) {
    return false;
  }

  const _siblingPrevious = nodeUtils.getPreviousSiblingChoice(dstElementParent, dstElement);

  return !_siblingPrevious || _siblingPrevious.id !== _srcId;
};
